import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'content-header-image',
  templateUrl: './header-image.component.html',
  styleUrls: ['./header-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ContentHeaderImageComponent {
  @Input() content?: any;

  loaded?: boolean;
  ideaDisabled = false;
  productionDisabled = false;
  constructor() {}
}
